import React, { useEffect, useRef, useState } from 'react'
import urltoFile from './../../components/urlToFile';
import { getGalleryImage, newGalleryImage, deleteGalleryImage } from './../../api/routes';
import { Backdrop, CircularProgress, Icon } from '@mui/material';
import imageCompression from 'browser-image-compression';
import { toast } from "react-toastify";

export default function Gallery() {
    const file = useRef(null);
    const [galleryImages, setGalleryImages] = useState([]);
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const [uploadProgress, setUploadProgress] = useState(false);
    useEffect(() => {
        handleOpen()
        getGalleryImage((isOk, data) => {
            if (!isOk) {
                handleClose();
                return toast.error(data.message);
            }
            else {
                handleClose();
                return setGalleryImages(data)
            }
        })
    }, [])

    const deleteImage = (galleryId) => {
        handleOpen()
        deleteGalleryImage(galleryId, (isOk, data) => {
            if (!isOk) {
                handleClose()
                return toast.error(data.message);
            }
            else return window.location.reload()
        })
    }

    const uploadImage = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            if (event.target.files[0].size / 1024 / 1024 < 10) {
                handleOpen()
                setUploadProgress(true);
                const reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                reader.onload = (event) => {
                    urltoFile(event.target.result, 'file.jpeg', 'image/jpeg')
                        .then(function (file) {
                            let options = {
                                maxSizeMB: 0.2,
                            }
                            imageCompression(file, options)
                                .then(function (compressedFile) {
                                    const formData = new FormData();
                                    formData.append("centerImage", new File([compressedFile], "file.jpeg", { type: "text/json;charset=utf-8" }));
                                    newGalleryImage(formData, (isOk, data) => {
                                        if (!isOk) {
                                            setUploadProgress(false);
                                            handleClose()
                                            return toast.error(data.message);
                                        }
                                        else {
                                            return window.location.reload();
                                        }
                                    })
                                })
                                .catch(function (error) {
                                    console.log(error.message);
                                });
                        })
                };
            } else toast.error("حجم فایل باید کمتر از 10 مگابایت باشد");
        }
    }

    return (
        <div style={{ padding: '1rem' }}>
            <input ref={file} type="file" accept="image/*" style={{ display: 'none' }} onChange={uploadImage} />
            <div style={{ borderRadius: '8px', display: 'flex', marginTop: '1rem', padding: '0 1rem', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #d2d6da', height: '56px' }} onClick={() => uploadProgress === false && file?.current?.click()}>
                <p style={{ color: '#00000099', fontSize: '1rem' }}>تصویر گالری</p>
                {!uploadProgress ? <p style={{ color: '#00000099', fontSize: '1rem' }}>آپلود کنید</p> : <p style={{ color: '#46cb81', fontSize: '1rem', fontWeight: 'bold' }}>در حال آپلود</p>}
            </div>
            <div style={{ display: 'flex', marginTop: '3rem', flexWrap: 'wrap' }}>
                {galleryImages.map((gallery) => <section key={gallery.departmentGalleryId} style={{ margin: '0 2rem', position: 'relative' }}>
                    <img src={`data:image/jpeg;base64,${gallery.image}`} alt='doctor' style={{ width: '300px', height: '200px', objectFit: 'cover' }} />
                    <Icon onClick={() => deleteImage(gallery.departmentGalleryId)} style={{ position: 'absolute', top: 0, left: 0, color: '#ff4949', cursor: 'pointer' }}>delete</Icon>
                </section>)}
            </div>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}
